import React, { Suspense, lazy } from 'react';
import './Footer.css';
import { socialLinks } from '../../config/socialLinks';

const Footer = () => {
  return (
    <footer className="footer">
      <p>Connect with me on:</p>
      <div className="social-icons">
        {Object.entries(socialLinks).map(([platform, url]) => {
          // Convert platform name to PascalCase (facebook → FaFacebook)
          const iconName = `Fa${platform.charAt(0).toUpperCase() + platform.slice(1)}`;
          
          // Lazy load the icon
          const IconComponent = lazy(() => import('react-icons/fa').then((icons) => ({ default: icons[iconName] })));

          return url ? (
            <a
              key={platform}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className={`social-icon ${platform}`}
              data-tooltip={platform.charAt(0).toUpperCase() + platform.slice(1)}
            >
              <Suspense fallback={<span>🔗</span>}>
                <IconComponent />
              </Suspense>
            </a>
          ) : null;
        })}
      </div>
    </footer>
  );
};

export default Footer;
